import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-navy text-center text-white" aria-label="Limited time offer" data-id="element-284" data-mp="369pga49jt16e">
      <div className="h-1.5 w-full bg-gold" aria-hidden="true" data-id="element-285" data-mp="31j922hxwlbiz" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-286" data-mp="31ho4skk7fehf">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.16em] text-mineral" data-id="element-287" data-mp="3g7lzljcn32fl">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-288" data-mp="3b9u0o5dkug1w" /> Launch pricing ends in
        </p>
        <Countdown className="mt-5" data-id="element-289" data-mp="3p7scb30ijydp" />
        <p className="mt-7 font-bold text-muted" data-id="element-290" data-mp="3p6pjuqnjlnvo">After that the price increases and never drops again.</p>

        <div className="mx-auto mt-6 max-w-xl rounded-lg border border-gold/40 bg-steel p-4 text-sm" data-id="element-291" data-mp="3l5driddaaojs">
          <p className="font-bold text-white" data-id="element-292" data-mp="1uwlwc58bwo4x">
            <span className="mr-2 inline-block h-2.5 w-2.5 animate-pulse rounded-full bg-mineral" data-id="element-293" data-mp="1qu8qzhxhus8o" />
            Remaining launch pricing spots: limited
          </p>
          <div className="mt-3 h-3 overflow-hidden rounded-full bg-navy" data-id="element-294" data-mp="2xsholqazf2gq">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '66%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9,
            ease: [0.23, 1, 0.32, 1]
          }} className="h-full rounded-full bg-mineral" data-id="element-295" data-mp="2xqoicc4a6k99" />
          </div>
          <p className="mt-1 text-right text-xs text-muted" data-id="element-296" data-mp="3ck00pd0q0cut">66% of spots taken</p>
        </div>
      </div>
      <div className="h-1.5 w-full bg-gold" aria-hidden="true" data-id="element-297" data-mp="3gl3hc1qlecx3" />
    </section>;
}